<div class="dialog-header">
    <h2>Clause Audit Log</h2>
    <ng-icon name="heroXMark" mat-dialog-close class="cursor-pointer"></ng-icon>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
    <div class="comparision" *ngIf="!nochange">
        <div>
            <p><strong>Log:</strong> Version {{ data.clauseData.version }} created by {{ data.clauseData.updatedBy
                }} on {{ getFormattedDate(data.clauseData.updatedDate) }}</p>
            <div *ngFor="let log of loggedClause" class="log-section">
                <p class="mb-0"><strong>{{ log.id }}:</strong></p>
                <p [innerHTML]="log.value"></p>
            </div>
        </div>
    </div>
    <div class="comparision" *ngIf="nochange">
        <div>
            <p>
                There is no change in the Clause.
            </p>
        </div>
    </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button color="primary" mat-raised-button class="outlined-btn" mat-dialog-close>Close</button>
</mat-dialog-actions>